export const COUNTRY_OPTIONS = [
    { key: "Canada", value:"CA", text: "Canada"},
    { key: "US", value:"US", text: "United States"},
];
